<template>
  <div class="c-iOS-monitor">
    <!-- filter -->
    <monitor-filter placeholder="请输入规则名称或ID" @on-change="filterData" @on-search="searchFilterData" />

    <!-- table -->
    <div class="c-table-list">
      <Viewport v-model="tableHeight">
        <monitor-table
          ref="targetingTable"
          :loading="loading"
          :height="tableHeight"
          :data="tableList"
          :columns="tableCols"
          @on-del="deleteRow"
          @on-refresh="getData"
        />

        <Page
          show-total
          show-sizer
          show-elevator
          :total="total"
          :current.sync="pageIndex"
          :page-size="pageSize"
          :page-size-opts="[10, 20, 30, 40, 100]"
          @on-change="changePageIndex"
          @on-page-size-change="changePageSize"
          class="c-table-page pager"
          size="small"
        />
      </Viewport>
    </div>
  </div>
</template>
<script>
import mixin from '../mixins/mixin'
import columns from '../data/iOS_monitor_column'
import { setLocal } from '@/common/js/api'
import { isArray, timeout } from '@/common/js/utils'
import { iOSMonitorList, deleteiOSMonitor } from '@/api/manage.model'
import MonitorFilter from './components/filter'
import MonitorTable from './components/table'

export default {
  name: 'iOSMonitor',
  mixins: [mixin],
  components: { MonitorFilter, MonitorTable },
  computed: {
    tableCols() {
      return this.columns.filter((ret) => !ret.show)
    }
  },
  methods: {
    getData(filter) {
      let params = {
        page: this.pageIndex,
        pageSize: this.pageSize
      }
      if (filter) params = Object.assign(params, filter)
      else params = Object.assign(this.params, params)
      this.params = JSON.parse(JSON.stringify(params))
      this.loading = true
      iOSMonitorList(params)
        .then((data) => {
          if (typeof data === 'symbol') return
          else this.loading = false
          const { list, page_info } = data
          if (isArray(list) && page_info) {
            const { total_number } = page_info
            this.total = total_number || 0
            this.tableList = list
          } else this.total = 0
        })
        .catch((err) => {
          this.$Message.error({
            duration: 5,
            content: err
          })
        })
    },
    deleteRow({ ruleId }) {
      this.loading = true
      deleteiOSMonitor({ ruleId }).then((data) => {
        this.loading = false
        if (data) {
          this.$Message.success('iOS监控规则删除成功！')
          timeout(600).then(() => {
            this.getData()
          })
        }
      })
    },
    setLocalPage(size) {
      setLocal('IOSMONITOR_PAGESIZE', size)
    }
  },
  data() {
    return {
      tableHeight: 330,
      tableList: [],
      columns: columns
    }
  }
}
</script>
<style lang="scss" scoped>
.c-iOS-monitor {
  .c-table-page {
    padding: 5px 0;
    text-align: right;
  }
}
</style>
